import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userSearch',
})
export class UserSearchPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    try {
      if (!value || !Array.isArray(value)) {
        return [];
      }
      if (!args || args.trim() === '') {
        return value; // Return full user list when search text is empty
      }

      // Optimize: Compute search values ONCE outside the loop
      const searchTerm = args.toLowerCase();
      const searchTermNoSpace = args.replace(/ /g, '').toLowerCase();

      const filteredUsers = value.filter((data) => {
        // Optimize: Prevent mutating original 'data' object on each digest loop computation
        const firstName = data?.firstName || '';
        const lastName = data?.lastName || '';
        const concatName = String(firstName) + String(lastName); // Matches existing logical behavior safely

        const fNameLower = firstName.toLowerCase();
        const lNameLower = lastName.toLowerCase();
        const roleLower = data?.role?.name?.toLowerCase() || '';
        const emailLower = data?.email?.toLowerCase() || '';
        const concatNameLower = concatName.replace(/ /g, '').toLowerCase();

        return (
          fNameLower.startsWith(searchTerm) ||
          lNameLower.startsWith(searchTerm) ||
          roleLower.startsWith(searchTerm) ||
          emailLower.startsWith(searchTerm) ||
          concatNameLower.startsWith(searchTermNoSpace)
        );
      });

      return filteredUsers.length ? filteredUsers : []; // Ensure an empty array is returned when no results are found
    } catch (error) {
      // console.log('🚀 ~ UserSearchPipe ~ transform ~ Error:', error);
      return []; // Return an empty array in case of error
    }
  }
}

@Pipe({
  name: 'documentPipe',
})
export class DocumentsPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    try {
      if (!value) return null;
      if (!args) return value;

      // Optimize: Extract `toLowerCase()` execution out of the array mapping scope
      const searchTerm = args.toLowerCase();

      return value.filter((data) => {
        return (
          data?.name?.toLowerCase().startsWith(searchTerm) ||
          data?.user?.firstName?.toLowerCase().startsWith(searchTerm) ||
          data?.user?.lastName?.toLowerCase().startsWith(searchTerm) ||
          data?.type?.toLowerCase().startsWith(searchTerm)
        );
      });
    } catch (error) {
      // console.log(error);
    }
  }
}
